import React from 'react';
import { cn } from '@/lib/utils';

interface Props {
  /** 'loading' = fetch in flight, 'empty' = fetch returned no bars.
   *  Visually the same — only the aria-label differs for screen readers. */
  state: 'loading' | 'empty';
  /** Pin a specific height. Otherwise the skeleton fills its parent. */
  height?: number;
  className?: string;
}

export function ChartSkeleton({ state, height, className }: Props) {
  return (
    <div
      style={height ? { height } : undefined}
      role="status"
      aria-label={state === 'loading' ? 'Loading chart' : 'No bars'}
      className={cn(
        'w-full h-full flex items-center justify-center gap-1',
        className,
      )}
    >
      {[0, 0.15, 0.3].map((delay) => (
        <span
          key={delay}
          aria-hidden="true"
          className="chart-skeleton-bar block w-1 h-3 bg-fg-subtle rounded-sm"
          style={{ animationDelay: `${delay}s` }}
        />
      ))}
    </div>
  );
}
